module.exports = __webpack_public_path__ + "static/media/bannerMain.350ac546.png";